import { Typography } from 'bonfire-kindling';
import { Page } from 'components';
import { useTranslation } from 'react-i18next';

const NotFound = () => {
  const { t } = useTranslation();
  return (
    <Page
      isTinted
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Typography component="h1">{t('not_found')}</Typography>
    </Page>
  );
};

export default NotFound;
